import { BIBLE_VERSE_COUNTS } from './verseCounts';

export function parseStoredVerses(text) {
  if (!text) return [];
  return text.split('\n')
    .map(line => { const m = line.match(/^(\d+)\s+(.*)/); return m ? { verse: parseInt(m[1], 10), text: m[2] } : null; })
    .filter(Boolean);
}

// Headings are stored as "#<verse> <text>" lines above the verse they belong to:
// Psalm superscriptions ("Of David") and Psalm 119's stanza letters ("ב (Beth)").
// Returns { [verse]: [heading, ...] }.
export function parseStoredHeadings(text) {
  if (!text) return {};
  const byVerse = {};
  for (const line of text.split('\n')) {
    const m = line.match(/^#(\d+)\s+(.*)/);
    if (!m) continue;
    const verse = parseInt(m[1], 10);
    (byVerse[verse] = byVerse[verse] || []).push(m[2]);
  }
  return byVerse;
}

// ── Static book/chapter helpers (no DB needed — data is already in BIBLE_VERSE_COUNTS) ──

// Chapter list for a book — lazily computed once per abbr, cached for the app lifetime
const _chapterListCache = {};
export function chaptersForBook(abbr) {
  if (!_chapterListCache[abbr]) {
    const count = (BIBLE_VERSE_COUNTS[abbr] || []).length;
    _chapterListCache[abbr] = Array.from({ length: count }, (_, i) => i + 1);
  }
  return _chapterListCache[abbr];
}
